/** Display amounts — update when Stripe prices change. */
export const PREMIUM_PLANS = {
  monthly: {
    key: "monthly",
    priceId: process.env.REACT_APP_STRIPE_MONTHLY_PRICE_ID || "",
    amount: process.env.REACT_APP_STRIPE_MONTHLY_PRICE || "7.99",
    /** Shown struck-through while a limited-time monthly promo is active. */
    regularAmount: process.env.REACT_APP_STRIPE_MONTHLY_REGULAR_PRICE || "7.99",
    promo:
      (process.env.REACT_APP_STRIPE_MONTHLY_PROMO ?? "false").toLowerCase() === "true",
    interval: "month",
    trialDays: Number(process.env.REACT_APP_STRIPE_MONTHLY_TRIAL_DAYS || "0"),
  },
  yearly: {
    key: "yearly",
    priceId: process.env.REACT_APP_STRIPE_YEARLY_PRICE_ID || "",
    amount: process.env.REACT_APP_STRIPE_YEARLY_PRICE || "59.99",
    interval: "year",
    monthlyEquivalent: process.env.REACT_APP_STRIPE_YEARLY_MONTHLY_EQ || "5.00",
  },
};

export function isPremiumCheckoutConfigured() {
  return Boolean(
    PREMIUM_PLANS.monthly.priceId &&
      PREMIUM_PLANS.yearly.priceId &&
      process.env.REACT_APP_SUPABASE_URL
  );
}
